import api from "services/api";

import { IBuscaPessoasResposta, IHistoricoResposta } from "./types";

export async function buscarPessoas(q: string): Promise<IBuscaPessoasResposta> {
  const r = await api.get<IBuscaPessoasResposta>("/insights/rh/pessoas", { params: { q } });
  return r.data;
}

/** Lista de "Fora do caminho comum" (spec §4.3): o código vem da aba, nunca é digitado. */
export async function buscarPorMotivo(motivo: string): Promise<IBuscaPessoasResposta> {
  const r = await api.get<IBuscaPessoasResposta>("/insights/rh/pessoas", { params: { motivo } });
  return r.data;
}

export async function abrirHistorico(cpf: string, workspaceId: string): Promise<IHistoricoResposta> {
  const r = await api.get<IHistoricoResposta>(`/insights/rh/pessoas/${cpf}/historico`, {
    params: { workspaceId },
  });
  return r.data;
}
